module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABkAAAAYCAMAAAA4a6b0AAAAUVBMVEUAAABWZ/1WZ/1WZ/1WZ/1WZ/1WZ/1WZ/1WZ/1WZ/1WZ/1WZ/1WZ/1WZ/1WZ/1WZ/1WZ/1WZ/1WZ/1WZ/1WZ/1WZ/1WZ/1WZ/1WZ/1WZ/1WZ/3q2xCuAAAAGnRSTlMADxb27MEJ6dyHUTYksPHk08rGW1pKQi0cuS4Aa6AAAABwSURBVCjPhdJJDoAgEATAEUURd3Ht/z/UgAdj0kBfK5nMJl+Uhr6EpQVg+phgYqSMp+pkNAfqGC2eRkbF6qk8CNU60M5oCGTfEr+oGz5OxDag2aQCTxOXRDXeHFyqaz5pfjt8o/wK/HLJa+c/hH/VAzKjE/e+xsZEAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./static/images/back.png
// module id = akd5
// module chunks = 1